import { createGlobalStyle } from 'styled-components';
import fontFaces from './font-faces';
import jakartaFontFaces from './jakarta-font-faces';
import appStyles from './app-styles';
import cssReset from './css-reset';

const GlobalStyle = createGlobalStyle`
  ${cssReset}
  ${fontFaces}
  ${appStyles}
  ${jakartaFontFaces}

  body {
    background-color: ${({ theme }) => theme.background} !important;
    color: ${({ theme }) => theme.content} !important;
  }
  * {
    font-family: 'Jost', sans-serif;
  }
`;

export default GlobalStyle;
